import axios from 'axios'

const getDesignationList = () => {
  return axios.get('/core/api/v1/designations')
}
export const designationService = {
  getDesignationList

}
